import { createContext, FC, ReactNode, useContext } from 'react'

import { UseEditConfigMenu, useEditConfigMenu } from '@components/ConfigEditMenu'

import { ENTITY_CONFIG_TYPE } from '@constants'

export const EditConfigContext = createContext<UseEditConfigMenu | null>(null)

interface Props {
  entityType: ENTITY_CONFIG_TYPE
  children: ReactNode
}

export const EditConfigProvider: FC<Props> = ({ entityType, children }) => {
  const menu = useEditConfigMenu(entityType)

  return (
    <EditConfigContext.Provider value={{ ...menu, entityType }}>
      {children}
    </EditConfigContext.Provider>
  )
}

export const useEditConfig = () => {
  const ctx = useContext(EditConfigContext)
  if (!ctx) {
    throw new Error('Context error inside <EditConfigProvider>')
  }

  return ctx
}
